var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstHeaderLogo2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.8 104",
    style: {
      enableBackground: "new 0 0 496.8 104"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DC1F26;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#3C3C3B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.3,50.1c0,27.7-22.4,50.1-50.1,50.1C22.4,100.3,0,77.8,0,50.1S22.4,0,50.1,0C77.8,0,100.3,22.4,100.3,50.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.1,68.7H41v-5.8H22.5V53h16.6v-5.8H22.5v-8.9H40v-5.8H16.1V68.7L16.1,68.7z M73.8,55.1 c-0.6,1.6-1.5,2.9-2.6,4.1c-1.1,1.1-2.4,2-3.9,2.7c-1.5,0.6-3.2,1-4.9,1c-1.8,0-3.4-0.3-4.9-1c-1.5-0.6-2.8-1.5-3.9-2.7 c-1.1-1.1-1.9-2.5-2.6-4.1c-0.6-1.6-0.9-3.3-0.9-5.1c0-1.8,0.3-3.5,0.9-5c0.6-1.5,1.5-2.9,2.5-4c1.1-1.1,2.3-2,3.8-2.6 c1.5-0.6,3.1-0.9,4.8-0.9c1.8,0,3.5,0.3,5,0.9c1.5,0.6,2.8,1.5,3.9,2.6c1.1,1.1,1.9,2.5,2.6,4c0.6,1.5,0.9,3.2,0.9,5 C74.7,51.8,74.4,53.5,73.8,55.1 M73.8,63.5v-0.1c0.9-0.5,1.7-1.1,2.6-1.9c0.9-0.7,1.7-1.7,2.5-2.8c0.7-1.1,1.4-2.4,1.8-3.8 c0.5-1.4,0.7-3.1,0.7-5c0-2.7-0.5-5.1-1.5-7.3c-1-2.2-2.4-4.2-4.1-5.8c-1.7-1.6-3.8-2.9-6-3.8c-2.3-0.9-4.7-1.4-7.3-1.4 c-2.6,0-5,0.5-7.3,1.4c-2.3,0.9-4.3,2.2-6,3.8c-1.7,1.6-3.1,3.5-4.1,5.8c-1,2.2-1.5,4.7-1.5,7.3c0,2.9,0.5,5.6,1.5,7.9 c1,2.3,2.4,4.3,4.1,5.9c1.8,1.6,3.8,2.9,6.2,3.7c2.4,0.9,5,1.3,7.8,1.3h21v-5.2H73.8L73.8,63.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.2,21.6v10H130V47h28.6v10H130v16.9h31.8v10H119V21.6H160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205,48h0.2v-6.3h10V104h-10.6V78.6h-0.3c-3.6,4.5-8.7,6.4-14.3,6.4c-12.5,0-20.4-10.2-20.4-22.2 c0-12.5,7.8-22.2,20.8-22.2C196.3,40.6,201.8,42.8,205,48z M192.6,75.5c7.1,0,12.4-5.4,12.4-12.7c0-6.8-4.8-12.7-12.5-12.7 c-7,0-12.3,5.5-12.3,12.7C180.2,70.1,185.5,75.5,192.6,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.8,41.7v21.8c0,8.4,2.6,12,7.7,12c6.2,0,9.7-4.2,9.7-10.7V41.7h10.6v42.2h-10v-6.8h-0.2 c-2.5,5.3-7,7.8-12.9,7.8c-12.3,0-15.4-9.3-15.4-16.3v-27H237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.9,27.3c0,3.8-3.1,6.3-6.9,6.3s-6.7-2.9-6.7-6.3c0-3.4,2.9-6.3,6.7-6.3C286.9,21,289.9,23.7,289.9,27.3z  M288.4,41.7v42.2h-10.6V41.7H288.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344.5,21.6v10h-19.1v52.3h-11.1V31.6h-19.1v-10H344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370,41.2v10.2c-2-0.5-3.5-0.8-5.1-0.8c-8,0-11.4,5.6-11.4,11.3v22H343V41.7h10.6v6.7h0.2 c2.3-4.8,7-7.7,12.5-7.7C367.8,40.6,368.6,40.9,370,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M413.1,58.7v25.3h-9.5v-5.8h-0.3c-3,4.8-7.9,6.9-13.6,6.9c-8.7,0-15.4-4.9-15.4-12.7c0-9.8,7.8-14.7,26-14.7 h3.3v-1.2c0-4.9-3.9-7.8-9.7-7.8c-4.4,0-8.4,1.8-11.3,4.4l-5.5-5.5c3.8-3.9,9.7-6.8,18-6.8C409.5,40.6,413.1,48.7,413.1,58.7z  M392.5,77.1c7.2,0,10.6-4,10.6-9.4V65h-3.1c-9.3,0-15,2-15,6.5C385,75.1,388.5,77.1,392.5,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M433.6,41.7l8.4,12.7l9.2-12.7h12.1l-14.4,19.5l17,22.7H453l-11-15.1l-11.1,15.1h-12.5l17-22.7l-14.6-19.5 H433.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M476.1,22.5v2.6h-3.6v9.4h-3v-9.4H466v-2.6H476.1z M483,22.5l2.9,7.8l2.9-7.8h4.1v12h-3v-7.8h-0.1l-2.9,7.8h-2 l-2.9-7.8h-0.1v7.8h-3v-12H483z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstHeaderLogo2X);
export default __webpack_public_path__ + "static/media/ast-header-logo@2x.67fb2786f4d0e154c067c1df1b400260.svg";
export { ForwardRef as ReactComponent };